import { Navigate, Outlet } from 'react-router-dom'
import { isAuthenticated } from 'common/util/Util.tsx'

const ProtectedRoute = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />
}

export default ProtectedRoute
